module.exports = __webpack_public_path__ + "img/u819.3379ef5c.png";